
export class verifyAccounts{
    sortCode:string;
    accountNumber:string;
}

export class verifyAccountsV2{
    sortCode:string;
    accountNumber:string;
    firstName:string;
    lastName:string;
    dateOfBirth:string;
    phoneNumber:string;
    userIdentifier:string;
    constructor(){
        this.sortCode='';
        this.accountNumber='';
        this.firstName='';
        this.lastName='';
        this.dateOfBirth='';
        this.phoneNumber='';
        this.userIdentifier='';
    }
}

// get existing role details

export class Roles{
    userRole:string;
    userPermission:string[];
}


export class RoleUpdate{
   userRole:string;
   clientId:string;
   permissions:string[];
   override:boolean;
}

export class NewRole{
    userRole:string;
    clientId:string;
    permissions:string[];
    override:boolean; 
}